module.exports = "query getCartUpsells($cartId: String!, $cartLines: [Float!]!) {\n  cartUpsells(cart: {id: $cartId, lines: $cartLines})\n}"